export const validDate = (dateString: string | Date) => {
  const d = new Date(dateString);
  // 1.1.1 are actually null values (.NET dos not support null for date types).
  return d.valueOf() !== 0;
};
